import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Col, Typography, Button, Divider, Space } from 'antd';
import HeaderBack from '../../../../components/mobile/HeaderBack';
import { ReactComponent as PhoneSvg } from '../../../../assets/icons/user-account/phone.svg';
import { ReactComponent as SignalSvg } from '../../../../assets/icons/user-account/signal.svg';
import { ReactComponent as TelegramSvg } from '../../../../assets/icons/user-account/telegram.svg';
import { ReactComponent as ViberSvg } from '../../../../assets/icons/user-account/viber.svg';
import { ReactComponent as WhatsappSvg } from '../../../../assets/icons/user-account/whatsapp.svg';

const { Title, Paragraph } = Typography;

function MobileSelectContactLoggedInScreen() {
  const { t } = useTranslation(['sign-up', 'common']);
  const history = useHistory();

  const onBack = () => {
    history.push('/user-account')
  }

  const onButtonClick = () => {
    history.push('/sign-up/loggedin/thank-you')
  }

  const onLinkClick = () => {
    history.push('/sign-up/loggedin/use-different-number')
  }

  const onShare = () => {
    history.push('/sign-up/loggedin/use-different-number')
  }

  return (
    <>
      <HeaderBack
        onBack={onBack}
        text={t('sign-up:returnToPreviousPage')}
        title={t('sign-up:howCanWeReachYou')}
        subtitle={t('sign-up:loggedIn.contactMethodSubtitle')}
      />
      <Row justify="center" align="middle" style={{ padding: 0}}>
        <Col xs={6}>
          <Row justify="center" align="middle">
            <ViberSvg onClick={onShare} />
          </Row>
        </Col>
        <Col xs={6}>
          <Row justify="center" align="middle">
            <SignalSvg onClick={onShare} />
          </Row>
        </Col>
        <Col xs={6}>
          <Row justify="center" align="middle">
            <WhatsappSvg onClick={onShare} />
          </Row>
        </Col>
        <Col xs={6}>
          <Row justify="center" align="middle">
            <TelegramSvg onClick={onShare} />
          </Row>
        </Col>
      </Row>
      <Box marginTop={35} marginBottom={35}>
        <Divider plain><p style={styles.divider}>{t('sign-up:or')}</p></Divider>
      </Box>
      <Button
        htmlType="button"
        type="primary"
        size="large"
        onClick={onButtonClick}
        block
      >
        <p style={styles.rowButton}>
          <PhoneSvg />{t('sign-up:callMeDirectlyMobile')}
        </p>
      </Button>
      <Box marginTop={10} marginBottom={10}>
        <Paragraph style={styles.textBottom}>
          {t('sign-up:weShallContactYou')}
        </Paragraph>
      </Box>
      <Row justify="center">
        <Button
          type="link"
          onClick={onLinkClick}
          style={styles.link}
        >
          {t('sign-up:useDiffrentNumber')} ?
        </Button>
      </Row>
    </>
  );
}

const styles = {
  divider: {
    fontSize: 14,
    fontWeight: 28,
    color: '#999999',
    margin: 0
  },
  rowButton: {
    margin: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 5
  },
  textBottom: {
    fontWeight: "300", 
    fontSize: "12px", 
    lineHeight: "18px", 
    textAlign: "center", 
    color: "#8C8C8C"
  },
  link: {
    fontWeight: 500
  }
}

export default MobileSelectContactLoggedInScreen;
